export enum DataSourceCode {
  EPO = 'EPO',
  UPV = 'UPV',
}
